
import { useState } from 'react'

import './MessageAttachmentsSection.sass'
import MessageAttachmentsSectionButton from './MessageAttachmentsSectionButton/MessageAttachmentsSectionButton'
import { getAttachmentType } from '@/helpers/attachments'
export function MessageAttachmentsSection (props) {
  const { attachments, max = 5 } = props

  if (!attachments || !attachments.length) return <></>

  const allViewableAttachments = attachments.filter((attachment) =>
    getAttachmentType(attachment.mimetype) !== null)

  const [showAll, setShowAll] = useState(false)

  return <section className="MessageAttachmentsSection">

    <div className="MessageAttachmentsSection-wrapper">
      {
        attachments
          .slice(0, showAll ? attachments.length : max)
          .map(attachment => {
            return <MessageAttachmentsSectionButton key={attachment.id} attachment={attachment} allAttachments={allViewableAttachments} />
          })
      }
      {
        attachments.length > max && (
          showAll
            ? <span className="-show_more" onClick={() => setShowAll(false)}>Show less</span>
            : <span className="-show_more" onClick={() => setShowAll(true)}>Show {attachments.length - 5} more</span>
        )
      }
    </div>
  </section>
}
